import mqtt from 'mqtt';
const REACT_APP_PARSING_SOCKET_URL = process.env.REACT_APP_PARSING_SOCKET_URL;
const REACT_APP_MQTT_USERNAME = process.env.REACT_APP_MQTT_USERNAME;
const REACT_APP_MQTT_PASSWORD = process.env.REACT_APP_MQTT_PASSWORD;
const socket = mqtt.connect(REACT_APP_PARSING_SOCKET_URL,
  {
    clientId: `react_wss_${Math.random().toString(16).slice(2)}`,

    username: REACT_APP_MQTT_USERNAME,
    password: REACT_APP_MQTT_PASSWORD
  }
);


socket.on("connect", () => {
  console.log("Connected via WSS");
});

socket.on("message", (topic, message) => {
  console.log(`${topic}: ${message.toString()}`);
});

socket.on("error", (err) => {
  console.error("MQTT Error:", err);
});

socket.on("close", () => {
  console.log("Connection closed");
});
export default socket;
